import { render, staticRenderFns } from "./BMap.vue?vue&type=template&id=d4d404e0&scoped=true"
import script from "./BMap.vue?vue&type=script&lang=js"
export * from "./BMap.vue?vue&type=script&lang=js"
import style0 from "./BMap.vue?vue&type=style&index=0&id=d4d404e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d404e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d404e0')) {
      api.createRecord('d4d404e0', component.options)
    } else {
      api.reload('d4d404e0', component.options)
    }
    module.hot.accept("./BMap.vue?vue&type=template&id=d4d404e0&scoped=true", function () {
      api.rerender('d4d404e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/tools/BMap.vue"
export default component.exports